import React, { useState, useRef, useEffect } from 'react';
import { useRouter } from 'next/router';
import cn from 'classnames';
import {
  Heading,
  HeadingEnum,
  BoldEnum,
  CookiesPage,
  CookiesModal,
  WaveBreadCrumb,
  TextColorEnum,
} from '@desquared/wave-components-library';
import Cookie from '@/store/cookies';

import { getTotalFields, setCookies, breadCrumbItems, getSidebarSection } from '@/utils/useCookies';
import { useTranslations } from 'next-intl';
import styles from './CookiesPage.module.css';
import ReactModal from 'react-modal';
import CUSTOM_STYLES from '@/utils/modalStyle.js';
import { useIsRtl } from '@/contexts/DirectionContext.jsx';

export default function Cookies(props) {
  const [showModal, setShowModal] = useState(false);
  const t = useTranslations('cookies');
  const [modalText, setModalText] = useState({
    title: t('modal.save_changes.title'),
    content: t('modal.save_changes.content'),
  });
  const router = useRouter();
  const isRtl = useIsRtl();

  const [selectedSidebarSectionIndex, setSelectedSidebarSectionIndex] = useState(0);
  const [cookiesOption, setCookiesOptions] = useState();
  const cookiesEl = useRef(null);
  const typeCookiesEl = useRef(null);
  const checkCookiesEl = useRef(null);
  const cookiesSettingsEl = useRef(null);
  const SIDEBAR_SECTION = getSidebarSection(props, cookiesEl, typeCookiesEl, checkCookiesEl, cookiesSettingsEl);
  function onChangeAd() {
    const tempCookies = { ...cookiesOption };
    tempCookies.ad = !cookiesOption.ad;
    setCookiesOptions(tempCookies);
  }
  function onClickSidebar(element, index) {
    element.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setSelectedSidebarSectionIndex(index);
  }
  function onChangeUX() {
    const tempCookies = { ...cookiesOption };
    tempCookies.ux = !cookiesOption.ux;
    setCookiesOptions(tempCookies);
  }
  function onChangePerformance() {
    const tempCookies = { ...cookiesOption };
    tempCookies.performance = !cookiesOption.performance;
    setCookiesOptions(tempCookies);
  }

  const onClickSave = () => {
    setModalText({ title: t('modal.accept.title'), content: t('modal.accept.content') });
    setCookies('acceptSelected', setCookiesOptions, cookiesOption);
    setShowModal(true);
  };
  const onClickDecline = () => {
    setModalText({ title: t('modal.reject.title'), content: t('modal.reject.content') });
    setCookies('declineAll', setCookiesOptions, cookiesOption);
    setShowModal(true);
  };
  const onClickAccept = () => {
    setModalText({ title: t('modal.save_changes.title'), content: t('modal.save_changes.content') });
    setCookies('acceptAll', setCookiesOptions, cookiesOption);
    setShowModal(true);
  };

  useEffect(() => {
    const _cookies = Cookie.getValue();
    if (!_cookies) {
      const cookiesUpdate = {
        necessary: true,
        performance: false,
        ad: false,
        ux: false,
      };
      Cookie.update(cookiesUpdate);

      setCookiesOptions(cookiesUpdate);
      return;
    }
    setCookiesOptions(_cookies);
  }, []);

  return (
    <div className={cn(styles.container)}>
      <div className={cn(styles.titles)}>
        <WaveBreadCrumb items={breadCrumbItems(t)} isRtl={isRtl} />
        <div className={cn(styles.titleSubtitle)}>
          <Heading color={TextColorEnum.OnSurfaceHighEmphasis} type={HeadingEnum.HeadingL} bold={BoldEnum.Bold}>
            {t('title')}
          </Heading>
        </div>
      </div>
      <CookiesPage
        onClickAccept={onClickAccept}
        onClickDecline={onClickDecline}
        onClickSave={onClickSave}
        acceptWording={t('accept_all')}
        declineWording={t('decline_all')}
        saveWording={t('save_all')}
        sidemenu={{
          sidebar_section: SIDEBAR_SECTION,
          selectedSidebarSectionIndex: selectedSidebarSectionIndex,
          onClickSidebar: onClickSidebar,
        }}
        fields={getTotalFields(
          cookiesEl,
          typeCookiesEl,
          checkCookiesEl,
          cookiesSettingsEl,
          props,
          cookiesOption,
          onChangePerformance,
          onChangeAd,
          onChangeUX,
          t,
          router.locale
        )}
      ></CookiesPage>
      {showModal && (
        <ReactModal
          isOpen={showModal}
          onRequestClose={() => setShowModal(false)}
          style={CUSTOM_STYLES}
          ariaHideApp={false}
          shouldCloseOnOverlayClick={true}
          className={styles.modalContent}
        >
          <CookiesModal
            title={modalText.title}
            description={modalText.content}
            primaryButtonWording={t('modal.close_modal')}
            onPrimaryClick={() => {
              setShowModal(false);
            }}
          />
        </ReactModal>
      )}
    </div>
  );
}
